import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';

/**
 * 案2-d Step 3 (Task A): bundle分離（案Z）.
 *
 * `REACT_APP_BUILD_TARGET` が:
 *   - "console" : 管理画面 bundle（Function App `wwwroot` に配置）
 *   - それ以外（"public" or unset）: 取引先入口 bundle（SWA `invoice.soumubucho.com`）
 *
 * Create React App + webpack 5 の DefinePlugin により `process.env.REACT_APP_BUILD_TARGET`
 * は build 時に文字列リテラルに静的置換される。下記の `if` 文は build 時に一方のブランチが
 * 到達不能（dead code）と判定され、`require()` 内部 module ごと webpack によって
 * bundle から完全に除外される。これが案Z「bundle完全分離」の肝。
 *
 * 実装ハマりポイント:
 *  - ES module の top-level `import` は副作用ありとみなされ tree-shake が効きにくい
 *    ことがあるため、ここでは webpack の `require()` 静的解析（webpack 4+）に乗せて
 *    片側を明示的に dead code 化する。
 *  - target 未指定で `npm run build` を叩くと `public` 扱い（取引先入口デフォルト）。
 *  - bundle の混入確認: `frontend/build/static/js/main.*.js` を grep して
 *    AdminLayout / VendorManagePage（console 専用）や InvoicePage / RegisterPage（public 専用）
 *    の文字列が反対側 bundle に含まれていないことを Step 3 Task C で確認する。
 */

let App: React.ComponentType;

if (process.env.REACT_APP_BUILD_TARGET === 'console') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
  App = require('./App.console').default;
} else {
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
  App = require('./App.public').default;
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
